import { Component, Input } from '@angular/core';

import { ForceFolder } from '../models';

@Component({
    standalone: false,
    selector: 'abs-force-folder-item',
    template: `
        <ion-icon class="folderIcon" name="folder-outline" color="medium"></ion-icon>
        <ion-label
            >{{ folder.name }} <span *ngIf="forceCount !== undefined" class="folder-count">({{ forceCount }})</span></ion-label
        >
    `,
    styles: [
        `
            :host {
                display: flex;
                align-items: center;
                flex: 1;
                overflow: hidden;
            }

            .folderIcon {
                margin-right: 10px;
                flex-shrink: 0;
            }

            ion-label {
                flex: 1;
                font-weight: bold;
            }

            .folder-count {
                font-weight: normal;
            }
        `
    ]
})
export class ForceFolderItemComponent {
    @Input() folder!: ForceFolder;
    @Input() forceCount: number | undefined = undefined;
}
